/**
 * Returns true when a given field name is unique among existing field names.
 * Uses case-insensitive comparison to prevent near-duplicate names.
 */
export function isUniqueFieldName(name: string, existingFieldNames: string[]): boolean {
  return !existingFieldNames.some(
    (f) => f.trim().toLowerCase() === name.trim().toLowerCase()
  );
}

/**
 * Returns the field name if it is unique. If the field name is not unique, it appends a number suffix (a number) to the field name.
 * This works recursively until a unique field name is determined.
 */
export function getUniqueFieldName(
  fieldName: string,
  existingFieldNames: string[]
): string {
  if (isUniqueFieldName(fieldName, existingFieldNames)) {
    return fieldName;
  } else {
    // eslint-disable-next-line no-constant-condition
    for (let fieldSuffixId = 1; true; fieldSuffixId++) {
      const name = `${fieldName} ${fieldSuffixId}`;
      if (isUniqueFieldName(name, existingFieldNames)) {
        return name;
      }
    }
  }
}
